/* unplugin-vue-components disabled */import { render } from "./RecommondComponent.vue?vue&type=template&id=f2569328&scoped=true"
import script from "./RecommondComponent.vue?vue&type=script&lang=js"
export * from "./RecommondComponent.vue?vue&type=script&lang=js"

import "./RecommondComponent.vue?vue&type=style&index=0&id=f2569328&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2569328"]])

export default __exports__